import {Component, OnInit} from '@angular/core';

import { Platform } from '@ionic/angular';
import { Router, ActivatedRoute} from '@angular/router';
import { MenuController } from '@ionic/angular';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import {OneSignal} from '@ionic-native/onesignal/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.scss', 'style-nav.scss'],
})
export class AppComponent implements OnInit{
  tabsOpenFlag = true;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private menu: MenuController,
    private oneSignal: OneSignal
  ) {
    this.initializeApp();
  }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      console.log(this.router.url);
      if (this.router.url === '/tabs/tab1' ||
        this.router.url === '/price-plan-frame' ||
        this.router.url === '/faq-frame' ||
        this.router.url === '/support-frame' ||
        this.router.url === '/guidance-frame' ||
        this.router.url === '/signup' ||
        this.router.url === '/whatsnew' ||
        this.router.url === '/login') {
        this.tabsOpenFlag = false;
      } else {
        this.tabsOpenFlag = true;
      }
    });
  }

  openFirst() {
    this.menu.enable(true, 'first');
    this.menu.open('first');
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.oneSignal.startInit('8c727be7-45d5-481b-a5c2-c8d272433fa3');
      this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);
      this.oneSignal.handleNotificationReceived().subscribe(() => {
        console.log('通知が届きました。');
      });
      this.oneSignal.handleNotificationOpened().subscribe(() => {
        console.log('通知を開きました。');
      });
      this.oneSignal.endInit();
    });
  }
}
